import { render, staticRenderFns } from "./AnnouncementAdministration.vue?vue&type=template&id=74958bfe&scoped=true"
import script from "./AnnouncementAdministration.vue?vue&type=script&lang=js"
export * from "./AnnouncementAdministration.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementAdministration.vue?vue&type=style&index=0&id=74958bfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74958bfe",
  null
  
)

export default component.exports